var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{pre:true,attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 12 12","fill":"none","stroke":"currentColor","stroke-width":"1.8","stroke-linecap":"round"}},[_c('path',{pre:true,attrs:{"d":"M6 1.5v9M1.5 6h9"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }